import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useIsLastTry = () => {
    const [isLastTry, setLastTry] = useState(false);

    const [searchParams] = useSearchParams();
    const tryCount = searchParams.get('try') || '';

    useEffect(() => {
        setLastTry(Number.parseInt(tryCount, 10) === 0);
    }, [tryCount]);

    return isLastTry;
};
